import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import dashboardSlice from './slices/dashboardSlice';
import productSlice from './slices/productSlice';
import orderSlice from './slices/orderSlice';
import userSlice from './slices/userSlice';
import categorySlice from './slices/categorySlice';
import promotionSlice from './slices/promotionSlice';
import saleSlice from './slices/saleSlice';
import watchVideoSlice from './slices/watchVideoSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    dashboard: dashboardSlice,
    products: productSlice,
    orders: orderSlice,
    users: userSlice,
    categories: categorySlice,
    promotions: promotionSlice,
    sales: saleSlice,
    watchVideos: watchVideoSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});
